import { render, staticRenderFns } from "./products.vue?vue&type=template&id=470eeac7&scoped=true&lang=html&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"
import style0 from "./products.vue?vue&type=style&index=0&id=470eeac7&lang=scss&scoped=true&"
import style1 from "./products.vue?vue&type=style&index=1&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470eeac7",
  null
  
)

export default component.exports